<template>
  <div class="progress">
    <van-tabs :color="isSimple?'#F65D27':'#185ED3'"
              v-model="activeName">
      <van-tab title="创建新图集"
               name="a">
        <div>
          <div class="in">
            <p>归属图库</p>
            <div class="mydiv"
                 @click="showPicker = true">{{chooseLib}}
              <img width="12vw"
                   src="@/assets/uploader/push.png" />
            </div>
            <van-popup v-model="showPicker"
                       round
                       position="bottom">
              <van-picker show-toolbar
                          :columns="libList"
                          @cancel="showPicker = false"
                          @confirm="onConfirm" />
            </van-popup>
          </div>
          <div class="in">
            <p>图集名称</p>
            <input class="myinput"
                   style="-webkit-appearance: none;"
                   type="text"
                   v-model="atlasName"
                   placeholder="图集名称不超过45字">
          </div>
          <div class="in">
            <p>图集说明</p>
            <textarea class="myinput shuoming"
                      style="-webkit-appearance: none;"
                      v-model="atlasDesc"
                      placeholder="图集说明不超过200字"></textarea>
          </div>
          <div class="in kbig">
            <p>可见性</p>
            <van-radio-group v-model="radio"
                             :disabled="statusFlag"
                             direction="horizontal">
              <van-radio name="0">私有
                <template #icon="props">
                  <img width="18px"
                       class="img-icon"
                       :src="props.checked ? isSimple?activeIconSimple: activeIcon : inactiveIcon" />
                </template>
              </van-radio>
              <van-radio name="1">公开
                <template #icon="props">
                  <img width="18px"
                       class="img-icon"
                       :src="props.checked ? isSimple?activeIconSimple: activeIcon : inactiveIcon" />
                </template>
              </van-radio>
            </van-radio-group>
          </div>

          <van-button @click="openClick"
                      round
                      class="btn"
                      type="info"
                      :color="isSimple?'#F65D27':'#185ED3'">上传</van-button>
          <van-button @click="openApushClick"
                      round
                      class="push"
                      type="info"
                      :color="isSimple?'#F65D27':'#185ED3'">上传并推送</van-button>
        </div>
      </van-tab>
      <van-tab title="归档到图集"
               name="b">
        <div>
          <div class="in">
            <p>指定图集</p>
            <input class="myinput"
                   @input="myLibChange"
                   style="-webkit-appearance: none;"
                   type="text"
                   v-model="myselect"
                   placeholder="请输入关键字进行筛选">
          </div>
          <div style="margin-top:3.8vw;">
            <el-table :data="myAtlas"
                      stripe
                      height="400"
                      @row-click="rowClick"
                      highlight-current-row
                      style="width: 100%;overflow-y: auto;">
              <el-table-column prop="name"
                               show-overflow-tooltip
                               label="图集名">
              </el-table-column>
              <el-table-column prop="date"
                               label="创建时间">
              </el-table-column>

            </el-table>
          </div>
          <van-button @click="goAtlas"
                      round
                      class="btn"
                      type="info"
                      :color="isSimple?'#F65D27':'#185ED3'">确定</van-button>
          <van-button @click="openAatlasClick"
                      round
                      class="push"
                      type="info"
                      :color="isSimple?'#F65D27':'#185ED3'">确定并推送</van-button>
        </div>
      </van-tab>
    </van-tabs>


    <van-popup v-model="showpushwork"
               @close="closevanPopup">
      <div class="pushWork">
        <div class="title">{{vantPopInfo.title}}
          <van-icon @click="showpushwork=false"
                    size="24px"
                    name="cross" />
        </div>

        <el-select v-model="pushUserName"
                   filterable
                   :placeholder="vantPopInfo.direction"
                   >
          <el-option v-for="item in liveList"
                     :key="item.value"
                     :label="item.text"
                     style="width:calc(100vw - 3vw);"
                     :value="item.value">
          </el-option>
        </el-select>
        <textarea class="textarea"
                  type="text"
                  maxlength="50"
                  placeholder="请输入备注,50字内"
                  v-model="pushUserTextarea"></textarea>
        <div class="btnp">
          <div class="cancle"
               @click="showpushwork=false">取消</div>
          <div class="sure"
               @click="surePush">确定</div>
        </div>
      </div>
    </van-popup>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { myActivityLive } from "@/api/activityLive";
import { listLib } from "@/api/lib";
import { addAtlas } from "@/api/atlas";
import Vue from 'vue';
import { Toast } from 'vant';
import { searchAtlas } from "@/api/search";
// import { allowLib } from "@/constants/powers";
import { getDate, formatConversion } from "@/plugins/getdate";
Vue.use(Toast);
export default {
  computed: {
    ...mapGetters(["createUid"])
  },
  data () {
    return {
      statusFlag: false,
      showPicker: false,
      chooseLib: '',
      chooseLibId: '',
      activeIcon: require('@/assets/uploader/checked.png'),
      activeIconSimple: require('@/assets/uploader/checkedSimple.png'),
      inactiveIcon: require('@/assets/uploader/nochecked.png'),
      libList: [],
      radio: '0',
      atlasName: '',
      atlasDesc: '',
      oldAltasName: '',
      oldAltasDesc: '',

      activeName: 'a',
      myselect: '',
      myAtlas: [],
      myLibId: 0,
      myAtlasId: 0,

      fileList: this.$store.state.user.fileList,
      allowLib: [],

      showpushwork:false,
      pushUserTextarea:'',
      pushUserName:'',
      liveList:[],
      vantPopInfo: {
        title: '推送至图片直播',
        direction: '请选择直播',
        id: 1
      },

      libInfo:''
    }
  },
  methods: {
    ...mapActions(["setAtlasId"]),
    ...mapActions(["setLibId"]),
    ...mapActions(["setIsUpload"]),
    surePush(){
      localStorage.setItem('live',JSON.stringify({
            pushChannelId: 'live',
            activityLiveId:this.pushUserName,
            note: this.pushUserTextarea,
      }))
      this.showpushwork = false
      if (this.myLibId === 0) {
        this.openClick()
      }else{
        this.goAtlas()
      }
    },
    closevanPopup(){

    },
    openApushClick(){
      if (this.atlasName === '') {
        Toast('请正确填写！')
        return
      }
      if (this.chooseLibId === '') {
        Toast('您没有可以上传的图库，请联系管理员添加！')
        return
      }
      if (this.atlasDesc.length > 200 || this.atlasName.length > 20) {
        Toast('图集名称最多不超过20个字符，图集说明最多不超过200个字符')
        return
      }
      this.myActivityLiveAsync()
      this.showpushwork = true
    },
    openAatlasClick(){
      if (this.myLibId === 0) {
        Toast('请选择图集')
        return
      }
      this.myActivityLiveAsync()
      this.showpushwork = true
    },
    async myActivityLiveAsync () {
      let {
        status,
        data,
        message,
        pagination
      } = await myActivityLive({
        pageSize: 200
      });
      if (status) {
        this.liveList = []
        for (let i = 0; i < data.length; i++) {
          if (data[i].status === 1) {
              this.liveList.push({
                value: data[i].id,
                text: data[i].title,
              });
          }
        }
      }
    },
    //归属到图集
    rowClick (row) {
      console.log(row);
      console.log(this.myAtlas);
      this.myLibId = row.libId
      this.myAtlasId = row.atlasId
      this.oldAltasName = row.title
      this.oldAltasDesc = row.desc
    },
    myLibChange () {
      if (!this.myselect) {
        this.myAtlas = []
        this.searchAtlasAsync({ pageSize: 20, page: 0, createUid: this.createUid })
      }
      if (this.myselect.length >= 2) {
        this.myAtlas = []
        this.searchAtlasAsync({ keyword: this.myselect, pageSize: 50, page: 0, createUid: this.createUid })
      }
      // this.myLibId = i.libId
      // this.myAtlasId = i.id
    },

    //获取个人图集
    async searchAtlasAsync (val) {
      let { status, data, message } = await searchAtlas(val);
      if (status) {
        for (let i = 0; i < data.length; i++) {
          // this.myAtlas.push({
          // name: '[' + data[i].libInfo.name + '] ' + data[i].name,
          // title: data[i].name,
          // desc: data[i].desc,
          // date: formatConversion(data[i].createAt.toString()),
          // libId: data[i].libId,
          // atlasId: data[i].id
          // });

          data[i].name = '[' + data[i].libInfo.name + '] ' + data[i].name
          data[i].title = data[i].name
          data[i].date = formatConversion(data[i].createAt.toString())
          data[i].atlasId = data[i].id
        }
        this.myAtlas = data
        // this.myAtlasId = this.myAtlas[0].label;
      } else {
        // this.$message.error(message);
      }
    },
    goAtlas () {

      if (this.myLibId !== 0) {
        this.setAtlasId(this.myAtlasId);
        this.setLibId(this.myLibId);
        localStorage.setItem('isUpload', true)
        this.setIsUpload(true)
        this.$router.push({ name: 'uploadprocess', query: { isOnly: false, atlasName: this.oldAltasName, atlasDesc: this.oldAltasDesc } })
      } else {
        Toast('请选择图集')
      }
    },

    openClick () {
      if (this.atlasName === '') {
        Toast('请正确填写！')
        return
      }
      if (this.chooseLibId === '') {
        Toast('您没有可以上传的图库，请联系管理员添加！')
        return
      }
      if (this.atlasDesc.length > 200 || this.atlasName.length > 20) {
        Toast('图集名称最多不超过20个字符，图集说明最多不超过200个字符')
        return
      }
      let atlasForm = {
        libId: this.chooseLibId,
        name: this.atlasName,
        desc: this.atlasDesc,
        status: this.radio,
        sourceType: "0",
        indexpicId: "0",
        createUid: this.createUid
      }
      this.addAtlasAsync(atlasForm)
      localStorage.setItem('isUpload', true)
      this.setIsUpload(true)
      this.$router.push({ name: 'uploadprocess', query: { isOnly: false, atlasName: this.atlasName, atlasDesc: this.atlasDesc } })
    },
    onConfirm (value,index) {
      if(value[1]){
        this.chooseLib = value[0] + '/' + value[1] 
        this.chooseLibId = [this.libList[index[0]].id,this.libList[index[0]].children[index[1]].id]
      }else{
        this.chooseLib = value[0]
        this.chooseLibId = [this.libList[index[0]].id]
      }
      
      
      this.showPicker = false
    },
    //获取图片库列表
    async listLibAsync () {
      let { status, data, message } = await listLib();

        for (let i = 0; i < data.length; i++) {
          if (this.allowLib.indexOf(data[i].id.toString()) !== -1 && data[i].status == 1) {
            this.libList.push({
              id: data[i].id,
              text: data[i].name,
              children:[]
            })
          }
        }
        if (this.libList.length > 0) {
          this.chooseLib = '请选择'
        } else {
          this.libList.push({
            text: '暂无'
          })
          this.chooseLib = this.libList[0].text
        }
      

      for (let i = 0;i < this.libList.length;i++) {
        let flag = 0
          for (let j = 0; j < this.allowLib.length; j++) {
            if(this.allowLib[j].toString().indexOf('-') !== -1){
              if(this.libList[i].id == this.allowLib[j].split('-')[0]){
                flag++
                this.libList[i].children.push({
                  id: this.allowLib[j].split('-')[1],
                  text: ''
                })
              }
            }
            
          }
          if(flag == 0){
            this.libList[i].children = [{id:'',text:''}]
          }
      }

      for (let i = 0; i < this.libList.length; i++) {
        if(this.libList[i].hasOwnProperty('children')){
          if(this.libList[i].children.length > 0){
            for (let z = 0; z < this.libList[i].children.length; z++) {
              for (let j = 0; j < data.length; j++) {
                if(data[j].id == this.libList[i].children[z].id){
                  this.libList[i].children[z].text = data[j].name
                }
                
              }
              
            }
            
          }
        }
        
        
      }

    },


    //创建图集
    async addAtlasAsync (val) {
      let libArr = val.libId
      if(libArr.length >= 2){
        val.parentLibId = parseInt(libArr[0])
        val.libId = parseInt(libArr[1])
      }else{
        val.parentLibId = 0
        val.libId = parseInt(libArr[0])
      }
      let { status, data, message } = await addAtlas(val);
      if (status) {
        this.setAtlasId(data.id);
        this.setLibId(data.libId);
      }
    },
    isLib (powersList, allowLib) {
      for (let i = 0; i < powersList.length; i++) {
        if (powersList[i].length > 4) {
          let start = powersList[i].substring(0, 3)
          if (start === 'lib') {
            allowLib.push(powersList[i].slice(4))
          }
        }
      }
    }
  },
  created () {
    this.isLib(JSON.parse(this.$route.query.powers), this.allowLib)
    this.listLibAsync()
    this.searchAtlasAsync({ pageSize: 20, page: 0, createUid: this.createUid })

    let createLength = 0
    console.log(JSON.parse(this.$route.query.powers).createPublicAtlas);

    if (JSON.parse(this.$route.query.powers).indexOf('createPrivateAtlas') !== -1) {
      this.statusFlag = true
      this.radio = '0'
    } else {
      createLength++
    }
    if (JSON.parse(this.$route.query.powers).indexOf('createPublicAtlas' !== -1)) {
      this.statusFlag = true
      this.radio = '1'
    } else {
      createLength++
    }

    if (createLength == 2) {
      this.statusFlag = true
      Toast('请联系管理员添加可见性的权限！')
    }

    if (createLength == 0) {
      this.statusFlag = false
      this.radio = '0'
    }

    if (!this.fileList) {
      Toast('图片获取失败,请重新选择！')
      localStorage.setItem('isUpload', true)
      setTimeout(() => {
        this.$router.push({
          path: '/uploader',
          query: {
            token: this.$route.query.token,
            date: this.$route.query.expirationTime,
            createUid: this.$route.query.createUid,
            powers: this.$route.query.powers
          }
        })
      }, 2000);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./progress.scss";
.el-table /deep/ .el-table__body .current-row td {
  background-color: #929292 !important;
}
.el-table /deep/ .el-table__body .current-row td .cell {
  color: #fff !important;
}

/deep/ .van-overlay,.van-popup {
    z-index: 2000 !important;
}
</style>